import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { AssetService } from '../../../asset/service/asset.service';
import { AuthService } from '../../../security/service/auth.service';
import { ProductUIMessages } from '../../model/product-ui.messages';
import { ProductModel } from '../../model/product.model';
import { ProductService } from '../../service/product.service';
import { ProductBaseComponent } from '../product-base.component';

@Component({
  selector: 'product-machine-data-view',
  templateUrl:
    './console/app-js/modules/product/components/product-machine-data-view/product-machine-data-view.component.html'
})
export class ProductMachineDataViewComponent extends ProductBaseComponent
  implements OnInit {
  @Input() productModel: ProductModel;
  @Output() productModelChange = new EventEmitter<ProductModel>();

  constructor(
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    productService: ProductService,
    assetService: AssetService
  ) {
    super(progressService, toastr, authService, productService, assetService);
  }

  ngOnInit(): void {
    this.onLoadProduct();
  }

  /**
   * Loads the product details by using the given product Id.
   */
  private onLoadProduct() {
    this.productService.getProductMachineData(this.productModel).subscribe(
      (res: any) => {
        this.partAndProductModel = res;
        this.partAndProductModel.isActive = this.productService.isProductActive(
          this.partAndProductModel.endDate
        );
        this.productModelChange.emit(this.partAndProductModel);
        // this.loadProductType(this.partAndProductModel.productType);
        this.progressRef.complete();
      },
      err => {
        console.log(err);
        this.onAPIError(ProductUIMessages.LOAD_PRODUCT_ERROR);
      }
    );
  }
}
